import 'FrontRoyalApiErrorHandler/angularModule';
import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const DisconnectedMobileInitDirective = angularDirectiveToReact('disconnectedMobileInit', {});

export function DisconnectedMobileInitComponent() {
    const [key] = useAngularToReactRoute();
    return <DisconnectedMobileInitDirective key={key} />;
}
